<template>
  <section id="pricing" class="pricing-section py-16">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="8">
          <div class="text-center mb-12">
            <p class="section-overline mb-2">PLANOS</p>
            <h2 class="section-title mb-4">Escolha o plano ideal</h2>
            <p class="section-subtitle">
              Soluções flexíveis para cada necessidade.
            </p>
          </div>

          <v-row justify="center">
            <v-col
              cols="12"
              sm="6"
              md="4"
              class="mb-4"
              v-for="(plan, i) in plans"
              :key="i"
            >
              <v-card
                class="pricing-card pa-6 text-center"
                :class="{ 'pricing-card--featured': plan.featured }"
                flat
              >
                <div v-if="plan.featured" class="pricing-badge mb-4">
                  Popular
                </div>

                <div class="pricing-icon-wrapper mx-auto mb-5">
                  <v-icon :color="plan.featured ? 'primary' : 'grey'" size="32">
                    {{ plan.icon }}
                  </v-icon>
                </div>

                <h3 class="pricing-plan-name mb-2">{{ plan.name }}</h3>

                <div class="pricing-price mb-1">
                  <span class="pricing-currency">R$</span>
                  <span class="pricing-amount">{{ plan.price }}</span>
                </div>
                <p class="pricing-period mb-6">por mês</p>
                <v-divider class="mb-5" />
                <div class="text-left mb-6">
                  <div
                    class="pricing-feature d-flex align-center mb-3"
                    v-for="(feature, j) in plan.features"
                    :key="j"
                  >
                    <v-icon
                      small
                      :color="feature.included ? 'primary' : 'grey lighten-1'"
                      class="mr-3"
                    >
                      {{
                        feature.included
                          ? "mdi-check-circle"
                          : "mdi-minus-circle-outline"
                      }}
                    </v-icon>
                    <span
                      class="pricing-feature-text"
                      :class="{
                        'pricing-feature-text--disabled': !feature.included,
                      }"
                    >
                      {{ feature.text }}
                    </span>
                  </div>
                </div>
                <v-btn
                  rounded
                  large
                  block
                  :color="plan.featured ? 'primary' : undefined"
                  :dark="plan.featured"
                  :outlined="!plan.featured"
                  depressed
                  class="pricing-btn"
                  @click="startSignup(plan)"
                >
                  Comece Agora
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
export default {
  data() {
    return {
      plans: [
        {
          name: "Básico",
          price: "20",
          icon: "mdi-send-outline",
          featured: false,
          features: [
            { text: "Domínios personalizados", included: true },
            { text: "Até 1.000 acessos diários", included: true },
            { text: "Suporte por e-mail", included: true },
            { text: "Relatórios avançados", included: false },
            { text: "API de integração", included: false },
          ],
        },
        {
          name: "Padrão",
          price: "100",
          icon: "mdi-airplane",
          featured: true,
          features: [
            { text: "Domínios personalizados", included: true },
            { text: "Até 10.000 acessos diários", included: true },
            { text: "Suporte prioritário", included: true },
            { text: "Relatórios avançados", included: true },
            { text: "API de integração", included: false },
          ],
        },
        {
          name: "Empresarial",
          price: "500",
          icon: "mdi-rocket-launch-outline",
          featured: false,
          features: [
            { text: "Domínios personalizados", included: true },
            { text: "Acessos ilimitados", included: true },
            { text: "Suporte dedicado 24/7", included: true },
            { text: "Relatórios avançados", included: true },
            { text: "API de integração", included: true },
          ],
        },
      ],
    };
  },

  methods: {
    /**
     * Leva para a etapa de cadastro do LoginPage (step=2), carregando o plano
     * escolhido na query para que a origem do lead não se perca.
     */
    startSignup(plan) {
      this.$router.push({
        name: "LoginPage",
        query: { step: "2", plan: plan.name.toLowerCase() },
      });
    },
  },
};
</script>
<style scoped>
.pricing-section {
  background-color: var(--ds-surface-white);
}
.section-overline {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--ds-primary);
  text-transform: uppercase;
}
.section-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: var(--ds-ink);
  letter-spacing: -0.3px;
  line-height: 1.2;
}
.section-subtitle {
  font-size: 1.05rem;
  font-weight: 300;
  color: var(--ds-gray);
}
.pricing-card {
  background: var(--ds-gray-50);
  border-radius: 16px !important;
  border: 1px solid #f0f0f0;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
}
.pricing-card--featured {
  background: var(--ds-surface-white);
  border-color: var(--ds-primary);
  box-shadow: 0 8px 32px rgba(77, 182, 172, 0.12) !important;
}
.pricing-badge {
  display: inline-block;
  background: var(--ds-blue-100);
  color: var(--ds-primary-deep);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 14px;
  border-radius: 100px;
}
.pricing-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pricing-card--featured .pricing-icon-wrapper {
  background: var(--ds-blue-100);
}
.pricing-plan-name {
  font-size: 1rem;
  font-weight: 500;
  color: var(--ds-gray-light);
  text-transform: uppercase;
  letter-spacing: 1px;
}
.pricing-price {
  color: var(--ds-ink);
}
.pricing-currency {
  font-size: 1.1rem;
  font-weight: 500;
  vertical-align: top;
  line-height: 1.8;
}
.pricing-amount {
  font-size: 2.75rem;
  font-weight: 700;
  letter-spacing: -1px;
}
.pricing-period {
  font-size: 0.85rem;
  color: #aaa;
}
.pricing-feature-text {
  font-size: 0.875rem;
  color: var(--ds-gray-mid);
}
.pricing-feature-text--disabled {
  color: #ccc;
}
.pricing-btn {
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0.2px;
}
@media (max-width: 960px) {
  .section-title {
    font-size: 1.75rem;
  }
}
</style>
